<template>
  <div class="director owner">
    <div class="container">
      <div
        class="director-sub"
        v-html="directorDesc2"
      />
      <div class="director-box">
        <div
          v-for="dr in director"
          :key="dr"
          class="director-card"
          @click="openModal(dr.id)"
        >
          <img
            :src="cdn + dr.image"
            alt=""
          >
          <h4 v-html="dr.title" />
          <h5 v-html="dr.position" />
        </div>
      </div>
      <modal
        :open="isOpen"
        @close="isOpen = !isOpen"
      >
        <div
          v-if="selectedDirector"
          class="modals"
        >
          <div class="modal-left">
            <img
              :src="cdn + selectedDirector.image"
              alt=""
            >
          </div>
          <div class="modal-right">
            <p
              class="name"
              v-html="selectedDirector.title"
            />
            <p
              class="position"
              v-html="selectedDirector.position"
            />
            <p
              class="par"
              v-html="selectedDirector.description"
            />
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import {ref} from 'vue'
import modal from '../components/windows/modalCompany.vue'
export default {
    components: {modal},
    setup() {
    const isOpen = ref(false)
        return {isOpen}
    },
    data() {
        return {
            director: [],
            directorDesc2: [],
            selectedModal: 0,
        }
    },
    computed :{
        ...mapState(['cdn']),
        selectedDirector(){
            return this.director.find(item => item.id === this.selectedModal)
        }
    },
    watch: {
      isOpen: function() {
        if(this.isOpen){
          document.documentElement.style.overflow = 'hidden'
          return
        }
        document.documentElement.style.overflow = 'auto'
      }
    },
    created() {
    axios.get('V1/company-managements')
        .then(response => {
            this.director = response.data.data.managers
            this.directorDesc2 = response.data.desc_2
        })
        .catch(e => {
            this.errors.push(e)
        })
    },
    methods:{
        openModal(id){
            this.selectedModal = id
            this.isOpen = true
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../assets/style/director.scss';
</style>